// ABOUTME: Tab configuration for the /software feedback triage overview page.
// ABOUTME: Tabs: the cross-customer feedback list and the pending work-order queue (ShDataGrid2).

import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

export const softwareFeedbackConfig = {
    all: {
        title: "all",
        icon: <FeedbackOutlinedIcon />,
        isSingleDataGrid: true,
    },
    workorders: {
        title: "feedback_work_orders",
        icon: <BuildOutlinedIcon />,
        isSingleDataGrid: true,
    },
};
